import axios from "axios";

const rawAxios = axios.create({
  baseURL: "https://dev-admin-api.pushkarchaubey.in/",
  timeout: 15000,
});

export default rawAxios;
